import HttpRequest from "@/plugins/http";

const request = new HttpRequest({
  baseURL: "/platform/v1",
});

const axios = request.request();

const ALLOWED_SSO_HOST_SUFFIXES = [
  ".mycwt.com.cn",
  ".mycwt.com",
  ".chuxingpay.com",
];

export function sanitizeJumpUrl(rawUrl) {
  if (typeof rawUrl !== "string" || !rawUrl.trim()) {
    return "";
  }
  try {
    const parsed = new URL(rawUrl, window.location.origin);
    const isHttp = parsed.protocol === "http:" || parsed.protocol === "https:";
    const isSameOrigin = parsed.origin === window.location.origin;
    const isAllowedHost = ALLOWED_SSO_HOST_SUFFIXES.some((suffix) =>
      parsed.hostname.endsWith(suffix)
    );
    return isHttp && (isSameOrigin || isAllowedHost) ? parsed.toString() : "";
  } catch (e) {
    return "";
  }
}

/**
 * User getOperator
 * @export
 * @returns
 */
export async function getOperator() {
  return axios.get("/user/getOperator");
}

/**
 * User getOperatorBasicInfo
 * @export
 * @returns
 */
export async function getOperatorBasicInfo() {
  return axios.get("/user/getOperatorBasicInfo");
}

/**
 * import harp
 * @export
 * @param {Object} params - 查看swagger
 * @returns
 */
export async function importHarpID(params) {
  return axios.post("/harpID/Import", params, {
    responseType: "text",
  });
}

/**
 * User SSO Jump Login Main WebSite.
 * @export
 * @param {Object} params -
 * @param {string} [params.jumpType] -
 * @param {string} [params.menuFunCode] -
 * @returns
 */
export async function jumpLogin(params) {
  return axios.get("/user/JumpLogin", params).then((res) => {
    if (res && Object.prototype.hasOwnProperty.call(res, "data")) {
      res.data = sanitizeJumpUrl(res.data);
    }
    return res;
  });
}

/**
 * User SSO Jump Login Main WebSite.
 * @export
 * @returns
 */
export async function userLoginOut() {
  return axios.get("/user/loginOut").then((res) => {
    if (res && Object.prototype.hasOwnProperty.call(res, "data")) {
      res.data = sanitizeJumpUrl(res.data);
    }
    return res;
  });
}

/**
 * Customer
 * get Customer MI
 * @export
 * @param {Object} params -
 * @param {string} [params.customerCode] - customer Code
 * @param {string} [params.flitProType] - Default value: 'JD'
 * @returns
 */
export async function getCustomerMI(params) {
  return axios.get("/customer/getCustomerMI", params);
}

/**
 * Customer lookup
 * @export
 * @param {Object} params -
 * @param {string} [params.customerCode] - customer Code
 * @param {integer} [params.pageIndex] - 当前页面号
 * @param {integer} [params.pageSize] - 每页数量
 * @returns
 */
export async function getCustomerLookup(params) {
  return axios.get("/customer/lookup", params);
}
export async function getServiceCharge(params) {
  return axios.get("/customer/getServiceCharge", params);
}
/**
 * Department
 * @export
 * @param {Object} params -
 * @param {string} [params.cusomerCode] - customer Code
 * @param {string} [params.deptIDs] - deptIDs
 * @returns
 */
export async function getDeptSearch(params) {
  return axios.get("/dept/search", params);
}

/**
 * Payment: Credit Card Validate
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function creditCardValidate(params) {
  return axios.post("/payment/creditCardValidate", params);
}

/**
 * Payment: pay
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function paymentPay(params) {
  return axios.post("/payment/pay", params);
}

/**
 * PointSale 新增与修改
 * @export
 * @param {JSON} 查看swagger
 * @returns
 */
export async function pointSaleSave(params) {
  return axios.post("/pos/save", params);
}

/**
 * PointSale 获取POS信息
 * @export
 * @param {Object} params -
 * @param {string} [params.posCode] -
 * @param {string} [params.customerCode] -
 * @param {string} [params.channelID] -
 * @param {integer} [params.page] - Default value : 1
 * @param {integer} [params.perPage] - Default value : 10
 * @returns
 */
export async function pointSearch(params) {
  return axios.get("/pos/search", params);
}

/**
 * Traveler lookup
 * @export
 * @param {Object} params -
 * @param {string} [params.TravelerCode] -
 * @param {string} [params.TravelerName] -
 * @param {string} [params.CompanyCode] -
 * @param {string} [params.DeptCode] -
 * @param {string} [params.StaffNum] -
 * @param {string} [params.Mobile] -
 * @param {integer} [params.PageIndex]
 * @param {integer} [params.PageSize]
 * @returns
 */
export async function travelerLookup(params) {
  return axios.get("/traveler/lookup", params);
}

/**
 * TripApproval
 * @export
 * @param {Object} params -
 * @param {string} [params.userCode] -
 * @param {string} [params.userID] -
 * @param {string} [params.tripOrderNo] -
 * @returns
 */
export async function searchTravelApplyOrder(params) {
  return axios.get("/trip/searchTravelApplyOrder", params);
}

/**
 * CreditCardCompany信用卡公司信息
 * @export
 * @returns
 */
export async function geCreditCard(params) {
  return axios.get("/CreditCardCompany/search", params);
}

/**
 * temporary/guestlist
 * @export
 * @param {Object} params -
 * @param {string} [params.UserCode] -
 * @param {string} [params.LoginId] -
 * @param {string} [params.PsgName] -
 * @param {string} [params.Mobile] -
 * @param {integer} [params.page]
 * @param {integer} [params.per_page]
 * @returns
 */
export async function getTemporaryGuestList(params) {
  return axios.get("/traveler/temporary/guestlist", params);
}

/**
 * Check Session：
 * @export
 * @returns
 */
export async function checkSession(params) {
  return axios.get("/user/checkSession", params);
}

/**
 * creditCard lookup
 * @export
 * @param {Object} params -
 * @param {string} [params.travelerCode] -
 * @param {integer} [params.page]
 * @param {integer} [params.per_page]
 * @returns
 */
export async function getCreditCardLookup(params) {
  return axios.get("/creditCard/lookup", params);
}

/**
 * GetUserMenuList
 * @export
 * @param {Object} params -
 * @param {integer} [params.page]
 * @param {integer} [params.per_page]
 * @returns
 */
export async function getUserGetUserMenuList(params) {
  return axios.get("/user/GetUserMenuList", params);
}

/**
 * 保存信用卡
 * @export
 * @param {Object} params -
 * @returns
 */
export async function getCreditCardAdd(params) {
  return axios.post("/creditCard/add", params);
}

/**
 * 删除信用卡
 * @export
 * @param {Object} params -
 * @returns
 */
export async function creditCardDelete(params) {
  return axios.post("/creditCard/delete", params);
}

/**
 * 查询行程单
 * @export
 * @param {Object} params -
 * @returns
 */
export async function serchHotelOrderEmail(params) {
  return axios.get("/inform/serchHotelOrderEmail", params);
}

/**
 * 查询行程单
 * @export
 * @param {Object} params -
 * @returns
 */
 export async function repeatHotelOrderEmail(params) {
  return axios.post("/inform/repeatHotelOrderEmail", params);
 }
 
 /* 获取userinfo
 * @export
 * @param {Object} params -
 * @param {string} [params.loginId]
 * @returns
 */
export async function getuserinfo(params) {
  return axios.get("/user/getUserInfo", params);
}



/**
 * 获取PosReasonCode信息
 * @export
 * @param {Object} params -
 * @param {string} [params.posCode]
 * @returns
 */
export async function posRCSearch(params) {
  return axios.get("/posRC/search", params);
}

/**
 * PosReasonCode Save
 * @export
 * @param {Object} params -
 * @returns
 */
export async function posRCSsave(params) {
  return axios.post("/posRC/save", params);
}
/**
 * 获取会员卡号
 * @export
 * @param {Object} params
 * @returns
 */
export async function getLoyaltyCardInfo(params) {
  return axios.get("/user/loyaltyCards", params);
}

/**
 * getExchangerate--获取汇率
 * @export
 * @returns
 */
export async function getExchangerate(params) {
  return axios.get("/api/exchangerate", params);
}

/**
 * 获取老酒店集团数据
 * @export
 * @param {Object} params
 * @returns
 */
export async function getHotelgroupInfo(params) {
  return axios.get("/hotelgroups/search", params);
}

/**
 * 新增与修改广告活动信息
 * @export
 * @param {Object} params
 * @returns
 */
export async function saveAds(params) {
  return axios.post("/Ads/save", params);
}

/**
 * 查询广告活动信息
 * @export
 * @param {Object} params
 * @returns
 */
export async function getAdsInfo(params) {
  return axios.post("/Ads/activitylist", params);
}

/**
 * 广告投放页列表查询
 * @export
 * @param {Object} params
 * @returns
 */
export async function getAdsList(params) {
  return axios.post("/Ads/list", params);
}

/**
 * 广告投放页列表更新是否客户接受
 * @export
 * @param {Object} params
 * @returns
 */
export async function updateisreceive(params) {
  return axios.post("/Ads/updateisreceive", params);
}

/**
 * 依据投放位置获取可绑定活动列表
 * @export
 * @param {Object} params
 * @returns
 */
export async function getActivityList(params) {
  return axios.get("/Ads/getActivityList", params);
}

/**
 * 依据投放位置获取可绑定活动列表
 * @export
 * @param {Object} params
 * @returns
 */
export async function saveAdvertiseDetail(params) {
  return axios.post("/Ads/saveAdvertiseDetail", params);
}

/**
 * 删除客户配置
 * @export
 * @param {Object} params
 * @returns
 */
export async function AdsDelete(params) {
  return axios.post("/Ads/delete", params);
}

/**
 * 新增客户配置
 * @export
 * @param {Object} params
 * @returns
 */
export async function addCusconfig(params) {
  return axios.post("/Ads/saveCusconfig", params);
}

/**
 * 依据客户选择展示不同广告
 * @export
 * @param {Object} params
 * @returns
 */
export async function getActivityListByCustomer(params) {
  return axios.get("/Ads/search", params);
}

/**
 * 查询短信模板
 * @export
 * @param {Object} params
 * @returns
 */
export async function searchSMSModel(params) {
  return axios.post("/inform/searchSMSModel", params);
}

/**
 * 重发短信
 * @export
 * @param {Object} params
 * @returns
 */
export async function sendSMS(params) {
  return axios.post("/inform/sendHotelOrderSMS", params);
}

/**
 * 获取客户酒店打标
 * @export
 * @param {Object} params
 * @returns
 */
export async function searchHotelMark(params) {
  return axios.get("/hotelMarkMapping/search", params);
}

/**
 * 保存客户酒店打标
 * @export
 * @param {Object} params
 * @returns
 */
export async function savehHotelMark(params) {
  return axios.post("/hotelMarkMapping/save", params);
}

/**
 * 删除客户酒店打标
 * @export
 * @param {Object} params
 * @returns
 */
export async function deletehHotelMark(params) {
  return axios.get("/hotelMarkMapping/delete", params);
}

/**
 * 获取短信日志记录接口
 * @export
 * @param {Object} params
 * @returns
 */
export async function smsOrderLogList(params) {
  return axios.get("/smsOrderLog/search", params);
}

/**
 * 获取成本中心接口
 * @export
 * @param {Object} params
 * @returns
 */
export async function searchCostCenter(params) {
  return axios.get("/pos/costcenter/search", params);
}

/**
 * 获保存成本中心接口
 * @export
 * @param {Object} params
 * @returns
 */
export async function saveCostCenter(params) {
  return axios.post("/pos/costcenter/save", params);
}

/**
 * 获取uatp卡详情
 * @export
 * @param {Object} params
 * @returns
 */
export async function getuatp(params) {
  return axios.get("/pos/costcenter/getuatp", params);
}

/**
 * 获取成本中心
 * @export
 * @param {Object} params
 * @returns
 */
export async function getCostCenter(params) {
  return axios.get("/pos/costcenter/getCostCenter", params);
}

/**
 * 获取成本中心
 * @export
 * @param {Object} params
 * @returns
 */
export async function getCostCenterModel(params) {
  return axios.get("/pos/costcenter/getcostcentermodel", params);
}

/**
 * 获取短信邮件通知配置
 * @export
 * @param {Object} params
 * @returns
 */
export async function getGlobalNotify(params) {
  return axios.get("/globalNotify/search", params);
}

/**
 * 保存短信邮件通知配置
 * @export
 * @param {Object} params
 * @returns
 */
export async function saveGlobalNotify(params) {
  return axios.post("/globalNotify/save", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getBankList() {
  return axios.get("/bankList");
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function verifySigning(params) {
  return axios.get("/verifySigning", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getPassengerLevel(params) {
  return axios.get("/pos/getPassengerLevel", params);
}

/**
 * Department
 * @export
 * @param {Object} params -
 * @param {string} [params.cusomerCode] - customer Code
 * @param {string} [params.deptIDs] - deptIDs
 * @returns
 */
export async function getCusDepProPayRule(params) {
  return axios.get("/dept/getCusDepProPayRule", params);
}

/**
 * 发送elong协议短信
 * @export
 * @param {Object} params
 * @returns
 */
export async function sendElongAgreeSMS(params) {
  return axios.post("/inform/sendElongAgreeSMS", params);
}

/**
 * 获取成本中心
 * @export
 * @param {Object} params
 * @returns
 */
export async function getOnlinePaymentType(params) {
  return axios.get("/pos/onlinePaymentType/search", params);
}

/**
 * 获取成本中心
 * @export
 * @param {Object} params
 * @returns
 */
export async function saveOnlinePaymentType(params) {
  return axios.post("/pos/onlinePaymentType/save", params);
}

/**
 * 获取上传的HarpId data
 * @export
 * @param {Object} params
 * @returns
 */
export async function getHarpIDMapping(params) {
  return axios.get("/harpID/search", params);
}

/**
 * 下载harpidmapping
 * @export
 * @param {Object} params
 * @returns
 */
export async function downloadHrapIdMapping(params) {
  return axios.post("/harpID/download", params,{
    responseType: "blob",
  });
}

/**
 * 获取发票抬头列表
 */
export async function getInvoiceHeaderList(params) {
  return axios.get("/invoice/getInvoiceHeaderList", params);
}

/**
 * 更新发票抬头
 */
export async function saveInvoiceHeader(params) {
  return axios.post("/invoice/saveInvoiceHeader", params);
}

/**
 * GetSwipeRates--获取刷卡费率
 * @export
 * @returns
 */
export async function getSwipeRates(params) {
  return axios.get("/api/GetSwipeRates", params);
}

/**
 * checkCreditCard--验证CTA卡有效性
 * @export
 * @returns
 */
export async function checkCreditCard(params) {
  return axios.get("/creditCard/check", params);
}

/**
 * 获取客户虚拟卡信息
 * @export
 * @param {Object} params
 * @returns
 */
export async function searchHotelVirtualCard(params) {
  return axios.get("/hotelVirtualCard/search", params);
}

/**
 * 获取客户虚拟卡信息
 * @export
 * @param {Object} params
 * @returns
 */
export async function searchPosHotelVirtualCard(params) {
  return axios.get("/hotelVirtualCard/searchPos", params);
}

/**
 * 删除客户虚拟卡信息
 * @export
 * @param {Object} params
 * @returns
 */
export async function deletehotelVirtualCard(params) {
  return axios.get("/hotelVirtualCard/delete", params);
}

/**
 * 保存虚拟卡信息
 * @export
 * @param {Object} params
 * @returns
 */
export async function savehotelVirtualCard(params) {
  return axios.post("/hotelVirtualCard/save", params);
}

/**
 * 保存证件信息
 * @export
 * @param {Object} params
 * @returns
 */
export async function addTemporary(params) {
  return axios.post("/user/addTemporary",params);
}
